// src/pages/RecentlyViewed.js
// Page "Récemment consultées" - remplace l'ancien onglet Voyages - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import ListingGrid from '../components/listing/ListingGrid';
import { useTheme } from '../hooks/useTheme';
import { getRecentlyViewed, clearRecentlyViewed } from '../utils/recentlyViewed';

const RecentlyViewed = () => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const [listings, setListings] = useState([]);

  useEffect(() => {
    setListings(getRecentlyViewed());
  }, []);

  const handleClear = () => {
    if (!window.confirm('Effacer tout l\'historique de consultation ?')) return;
    clearRecentlyViewed();
    setListings([]);
  };

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: theme.bg },
    header: {
      display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px',
      position: 'sticky', top: 0, backgroundColor: theme.bg, zIndex: 50, borderBottom: `1px solid ${theme.borderSoft}`,
    },
    title: { fontSize: '22px', fontWeight: '700', color: theme.textPrimary },
    clearBtn: { fontSize: '13px', fontWeight: '600', color: theme.gold, background: 'none', border: 'none', cursor: 'pointer' },
    subtitle: { padding: '8px 16px', fontSize: '14px', color: theme.textSecondary },
    emptyContainer: {
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '64px 24px', textAlign: 'center', gap: '12px',
    },
    emptyIcon: { fontSize: '56px', opacity: 0.4 },
    emptyTitle: { fontSize: '16px', fontWeight: '600', color: theme.textPrimary },
    emptyText: { fontSize: '14px', color: theme.textSecondary, maxWidth: '280px', lineHeight: '1.5' },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Récemment consultées | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <div style={styles.title}>👀 Récemment consultées</div>
        {listings.length > 0 && (
          <button style={styles.clearBtn} onClick={handleClear}>Effacer</button>
        )}
      </div>

      {listings.length > 0 ? (
        <>
          <div style={styles.subtitle}>
            {listings.length} annonce{listings.length > 1 ? 's' : ''} consultée{listings.length > 1 ? 's' : ''}
          </div>
          <ListingGrid listings={listings} loading={false} />
        </>
      ) : (
        <div style={styles.emptyContainer}>
          <div style={styles.emptyIcon}>👀</div>
          <div style={styles.emptyTitle}>Aucune annonce consultée</div>
          <div style={styles.emptyText}>
            Les annonces que vous ouvrez apparaîtront ici automatiquement, pour les retrouver facilement.
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentlyViewed;